// Copyright (c) Move Closer 2022.

import { MappingConfig } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const siteAdapterMap: MappingConfig = {
  address: 'address',
  domain: 'domain',
  favicon: 'favicon',
  id: 'id',
  locale: 'locale',
  logo: 'logo',
  name: 'name',
  properties: 'properties',
  postfix: 'postfix',
  currency: 'currency'
}
